import { Stack } from '@dtx-company/design-system/src'
import { Text } from '@dtx-company/shared-components/src'
import React from 'react'
import styled from 'styled-components'

const Title = styled(Text)`
  line-height: 24px;
`

type StepHeaderProps = {
  id?: string
  title: string
  subTitle?: string
}

const StepHeader = ({ id, title, subTitle }: StepHeaderProps): JSX.Element => {
  return (
    <Stack direction="row" sx={{ alignItems: 'center' }} spacing={3}>
      <Title variant="header/subheader" id={id} component="span">
        {title}
      </Title>
      {subTitle && (
        <Text as="span" variant="body/small">
          {subTitle}
        </Text>
      )}
    </Stack>
  )
}

export default StepHeader
